
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/element-4"}},[_c('path',{attrs:{"d":"M32.95 22.916h-6.733c-3.342 0-4.967-1.554-4.967-4.75V6.833c0-3.2 1.625-4.75 4.967-4.75h6.733c3.342 0 4.967 1.55 4.967 4.75v11.333c0 3.197-1.625 4.75-4.967 4.75zM26.217 4.583c-2.094 0-2.467.59-2.467 2.25v11.333c0 1.66.373 2.25 2.467 2.25h6.733c2.094 0 2.467-.59 2.467-2.25V6.833c0-1.66-.373-2.25-2.467-2.25z","fill":"#245389"}}),_c('path',{attrs:{"data-name":"Vector","d":"M32.95 37.917h-6.733c-3.342 0-4.967-1.55-4.967-4.75v-3c0-3.2 1.625-4.75 4.967-4.75h6.733c3.342 0 4.967 1.55 4.967 4.75v3c0 3.2-1.625 4.75-4.967 4.75zm-6.733-10c-2.094 0-2.467.59-2.467 2.25v3c0 1.66.373 2.25 2.467 2.25h6.733c2.094 0 2.467-.59 2.467-2.25v-3c0-1.66-.373-2.25-2.467-2.25z","fill":"#f29030"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.05 17.083h6.733c3.342 0 4.967 1.55 4.967 4.75v11.333c0 3.2-1.625 4.75-4.967 4.75H7.05c-3.342 0-4.967-1.554-4.967-4.75V21.833c0-3.2 1.625-4.75 4.967-4.75zm6.733 18.333c2.094 0 2.467-.59 2.467-2.25V21.833c0-1.66-.373-2.25-2.467-2.25H7.05c-2.094 0-2.467.59-2.467 2.25v11.333c0 1.66.373 2.25 2.467 2.25z","fill":"#245389"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.05 2.083h6.733c3.342 0 4.967 1.55 4.967 4.75v3c0 3.2-1.625 4.75-4.967 4.75H7.05c-3.342 0-4.967-1.55-4.967-4.75v-3c0-3.2 1.625-4.75 4.967-4.75zm6.733 10c2.094 0 2.467-.59 2.467-2.25v-3c0-1.66-.373-2.25-2.467-2.25H7.05c-2.094 0-2.467.59-2.467 2.25v3c0 1.66.373 2.25 2.467 2.25z","fill":"#f29030"}})])])
          )
        }
      }
    